import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { Accordion } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faFileWord, faFileVideo } from '@fortawesome/free-solid-svg-icons';
import Breadcrumb from "../Breadcrumb";

import CreateGetUsefulDocumentsAction from "../../store/actionCreators/CreateGetUsefulDocumentsAction";

class PublicUsefulDocumentsPage extends Component {
    constructor() {
        super();

        this.doLogin = this.doLogin.bind(this);

        this.state = {
            collapsed: true,
            userIsAuthenticated: false
        };
    }

    async componentDidMount() {
        this.props.getUsefulDocuments();

        try {
            // Call server to check if the user is authenticated
            const res = await fetch("/Account/whoami", { credentials: "include" });
            if (res.ok) {
                const user = await res.json();
                this.setState({ userIsAuthenticated: !!user.username });
            } else {
                this.setState({ userIsAuthenticated: false });
            }
        } catch (err) {
            console.error("Error checking authentication:", err);
            this.setState({ userIsAuthenticated: false });
        }
    }

    doLogin() {
        const { history } = this.props;

        // Call to check if already logged in
        fetch("/Account/whoami", { credentials: "include" })
            .then(res => res.json())
            .then(user => {
                if (user.username) {
                    // Already logged in, go to dashboard
                    history.push("/dashboard");
                } else {
                    // Not logged in, redirect to MVC login page
                    window.location.href = "/Account/Login";
                }
            })
            .catch(err => {
                console.error("Error checking login status:", err);
                // fallback to login page
                window.location.href = "/Account/Login";
            });
    }

    render() {

        //const t = this.props.t;
        const { t } = this.props;

        const usefulDocumentNonVideos = this.props.usefulDocs.length > 0
            ? this.props.usefulDocs.filter(x => x.mimeType !== "video/mp4")
            : null;

        const getIcon = (parameter) => {
            switch (parameter) {
                case "application/msword":
                    return <FontAwesomeIcon icon={faFileWord} style={{ fontSize: 4 }} />;
                case "video/mp4":
                    return <FontAwesomeIcon icon={faFileVideo} style={{ fontSize: 4 }} />;
                default:
                    return <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 4 }} />;
            }
        }

        return (
            <React.Fragment>

                <Breadcrumb
                    role=""
                    homeLink={t("Common.ButtonText.Home")}
                    pageName={t("PublicLandingPage.UsefulDocuments")} />

                <div className="row">
                    <div className="col-md-12">
                        <div className="h5 text-center">{t("PublicUsefulDocumentsPage.UsefulDocuments")}</div>
                    </div>
                </div>
                <hr className="srl-hr" />
                <div className="mb-5">
                    {
                        this.props.usefulDocs.length > 0 &&
                        <Accordion flush>
                            {
                                usefulDocumentNonVideos && usefulDocumentNonVideos.map((x, index) => {
                                    return (
                                        <Accordion.Item key={index} eventKey={x.id}>
                                            <Accordion.Header><strong>{x.name}</strong></Accordion.Header>
                                            <Accordion.Body>
                                                {
                                                    getIcon(x.mimeType)
                                                }
                                                <Link className="mx-2" to={"/usefulDocuments/" + x.path} target="_blank" download>{x.name}</Link>               
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    );
                                })
                            }
                        </Accordion>
                    }
                </div>
                <p>&nbsp;</p>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        usefulDocs: state.usefulDocuments || []
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getUsefulDocuments: () => {
            dispatch(CreateGetUsefulDocumentsAction());
        }
    };
};

const languageAwareComponent = withTranslation()(withRouter(PublicUsefulDocumentsPage));

export default connect(mapStateToProps, mapDispatchToProps)(languageAwareComponent);